<div class="page-content-container">
  <div class="header-container">
    <app-datasafra-search
      (search)="handleSearch($event)"
    ></app-datasafra-search>

    <button
      mat-flat-button
      extended
      (click)="navigateToCreatePage()"
      [disabled]="
        canCreateRequest() === false ||
        ((buttonLoading$ | async) ?? false) ||
        ((globalLoading$ | async) ?? false)
      "
    >
      @if ((buttonLoading$ | async) ?? false) {
        <mat-icon>hourglass_empty</mat-icon>
      } @else {
        <mat-icon>add</mat-icon>
      }
      Solicitar análise
    </button>
  </div>

  <app-requests-table
    [dataSource]="dataSource"
    [isLoading]="(gridLoading$ | async) ?? false"
    [length]="length"
    [config]="tableConfig"
    [actions]="tableActions"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (refresh)="onRefresh()"
    (rowToggle)="onRowToggle($event)"
    (viewAdminClick)="handleViewAdmin($event)"
  >
    <ng-template #expandedDetailTemplate let-el>
      @let element = asTypedItem(el);
      <div class="requests-element-diagram">
        <div class="requests-detail-row">
          <span>
            <b>Nº de relatórios desta solicitação:</b>
            {{ element.featureCount ?? "-" }}
          </span>
        </div>
        <div class="requests-detail-row">
          <span>
            <b>Nº total de relatórios solicitados e executados:</b>
            {{ element.requestedAndExecutedReportsCount ?? "-" }}
          </span>
        </div>
        <div class="requests-detail-row">
          <span>
            <b>Status da solicitação:</b>
            {{ element.status.description }}
          </span>
        </div>
        @if (
          element.status.code === "COMPLETED" ||
          element.status.code === "FAILED"
        ) {
          <div class="requests-detail-row">
            <span>
              <b>Data do evento:</b>
              {{ element.lastModifiedDate | date: "dd/MM/yyyy HH:mm:ss" }}
            </span>
          </div>
        }
        @if (element.status.code === "FAILED") {
          <div class="requests-detail-row">
            <span>
              <b>Motivo do cancelamento:</b>
              {{ element.error ?? "-" }}
            </span>
          </div>
          <div class="requests-detail-row">
            <span>
              <b>Cancelado por:</b>
              {{ element.lastModifiedByUser?.email }}
            </span>
          </div>
        }
      </div>
    </ng-template>
  </app-requests-table>
</div>
